export default [
    {
        title: 'AI Bot',
        icon: 'MessageCircleIcon',
        tagVariant: 'light-warning',
        resource: 'ai-bot',
        action: 'read',
        children: [
            {
                title: 'Chat Bot',
                route: 'chat-bot',
                resource: 'ai-bot',
                action: 'read',
            },
            {
                title: 'Web Chat',
                route: 'web-chat',
                resource: 'ai-bot',
                action: 'read',
            },
            {
                title: 'Leads',
                route: 'ai-leads',
                resource: 'ai-bot',
                action: 'read',
            },
            {
                title: 'Voice Bot',
                route: 'voice-bot',
                resource: 'ai-bot',
                action: 'read',
            },
            // {
            //     title: 'Service',
            //     route: 'phonebook-service-lists',
            //     resource: 'Phonebook Service',
            //     action: 'read',
            // },
        ],
    },
]
  